module.exports = __webpack_public_path__ + "img/ccdsjfqr.231626b6.png";